<template>
    <div class="relative" ref="container">
        <v-select
            :components="{Deselect}"
            :class="{'error': error}"
            v-model="value"
            :options="options"
            :label="labelKey"
            :reduce="reduce"
            :disabled="readonly"
            @open="focus"
            @close="blur"
        >
            <template v-if="$slots['no-options']" #no-options="{ search, searching, loading }">
                <slot name="no-options" :search="search" :searching="searching" :loading="loading"></slot>
            </template>

            <template v-if="readonly" #open-indicator="{attributes}">
                <span><!-- empty --></span>
            </template>
        </v-select>

        <label 
            @click="focus"
            :class="labelClasses"
            ref="placeholder"
        >
            {{ placeholder }}
        </label>
    </div>
</template>
<script>
import vSelect from 'vue-select';
import inputs from '@/Mixins/inputs';
import InputError from '@/Components/Forms/Inputs/InputError.vue';
import { markRaw } from 'vue';

export default {
    mixins: [inputs],
    components: {InputError, vSelect},
    props: {
        options: Array,
        labelKey: String,
        reduce: Function,
        readonly: Boolean
    },
    data() {
        return {
            Deselect: markRaw({
                render: () => { return "" }
            })
        }
    },
    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.v-select {
    @apply h-[52px] cursor-pointer;

    --vs-controls-color: theme('colors.dark');
    --vs-border-color: theme('colors.dark');
    --vs-border-width: 2px;
    --vs-border-style: solid;
    --vs-border-radius: theme('borderRadius.DEFAULT');
    --vs-search-input-color: theme('colors.dark');
    --vs-selected-bg: theme('colors.white');
    --vs-selected-color: theme('colors.dark');
    --vs-selected-border-color: theme('colors.primary');
    --vs-dropdown-option-color: theme('colors.dark');
    --vs-dropdown-option--active-bg: theme('colors.primary');
    --vs-dropdown-option--active-color: theme('colors.white');
    --vs-search-input-placeholder-color: #6e7583;
    --vs-disabled-bg: transparent;

    :deep(.vs__dropdown-toggle) {
        @apply h-full bg-white cursor-pointer;
    }

    :deep(.vs__selected-options) {
        @apply items-center flex-nowrap overflow-x-scroll;
    }

    :deep(.vs__selected) {
        @apply whitespace-nowrap;
    }

    :deep(.vs__search) {
        @apply cursor-pointer;
    }

    &.vs--open {
        --vs-border-color: theme('colors.primary') !important;
    }

    &.error {
        --vs-border-color: theme('colors.danger');
    }
}

</style>
